'use client';

import { useState } from 'react';
import { useBlogTheme } from '@/hooks/useBlogTheme';

export const BlogFAQs = ({ faqs, heading = 'Frequently Asked Questions' }) => {
  const [openIndex, setOpenIndex] = useState(null);
  const { isBlogLightTheme } = useBlogTheme();

  if (!faqs || faqs.length === 0) return null;

  // Extract and sort FAQ data
  const faqData = faqs
    .map((faq) => ({
      id: faq.id,
      sort: faq.sort,
      question: faq.blog_faqs_id?.question,
      answer: faq.blog_faqs_id?.answer,
      status: faq.blog_faqs_id?.status,
    }))
    .filter((faq) => faq.status === 'published' && faq.question && faq.answer)
    .sort((a, b) => a.sort - b.sort);

  if (faqData.length === 0) return null;

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section
      id="blogFaq"
      className={`w-full ${isBlogLightTheme ? 'text-black' : 'text-white'}`}
    >
      <h3 className="text-2xl md:text-3xl font-inter-tight text-center mb-8 md:mb-12">
        {heading}
      </h3>

      <div className="space-y-4">
        {faqData.map((faq, index) => (
          <div
            key={faq.id}
            className={`border rounded-lg overflow-hidden transition-colors ${
              isBlogLightTheme
                ? 'border-gray bg-white'
                : 'border-[#0C3438] bg-transparent bg-gradient-to-b from-[#1717172b] via-[#2d37372b] to-[#1717172b]'
            }`}
          >
            <button
              onClick={() => toggleFAQ(index)}
              className={`w-full px-6 py-4 flex items-center justify-between text-left transition-colors`}
              aria-expanded={openIndex === index}
              aria-controls={`faq-answer-${faq.id}`}
            >
              <span className="text-[18px] font-inter-tight font-medium pr-4">
                {faq.question}
              </span>
              <div
                className={`chevron transition-transform ${
                  isBlogLightTheme ? 'invert' : ''
                } ${openIndex === index ? 'up' : 'down'}`}
                aria-hidden="true"
              />
            </button>

            <div
              id={`faq-answer-${faq.id}`}
              className={`overflow-hidden transition-all duration-300 ease-in-out ${
                openIndex === index
                  ? 'max-h-[1000px] opacity-100'
                  : 'max-h-0 opacity-0'
              }`}
              role="region"
              aria-labelledby={`faq-question-${faq.id}`}
            >
              <div
                dangerouslySetInnerHTML={{ __html: faq.answer }}
                className={`text-[16px] font-inter-tight leading-relaxed px-6 pb-4 pt-2 ${
                  isBlogLightTheme ? 'text-gray-700' : 'text-gray-300'
                }`}
              ></div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};
